import {
  ButtonTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../../domain/amplitude'
import { Address, AutoCompleteAddressResult } from '../../../domain/address'
import { PROMO_SCREEN } from '../PromoCode/types'

export type AddressFormProps = {
  loading: boolean
  suggestions: AutoCompleteAddressResult[]
  formData: PersonalQuestionValues
  setFormData: (data: PersonalQuestionValues) => void
  setFormError: (error: string | null) => void
  getSuggestions: (address: Address) => Promise<void>
}

export type NameFields = {
  givenName: string
  familyName: string
  middleName: string
}

export type PersonalQuestionValues = {
  address: Address
  name: NameFields
}

export type Option = {
  id: string
  label: string
  value: string
}

export type AddressOption = Option & {
  value: AutoCompleteAddressResult
}

export type AddressState = {
  address: AddressSuggestion
  name: NameFields
}

export type AddressSuggestion = Address & {
  suggestion: AddressOption | null
}

const STATES_ABBR = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
]

export const stateOptions: Option[] = [
  ...STATES_ABBR.map((abbr) => ({
    id: abbr,
    label: abbr,
    value: abbr
  })),
  ...[
    {
      id: '',
      label: '',
      value: ''
    }
  ]
]

export const ADDRESS_SCREEN = 'application_info1'

export const AddressScreenOpened: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  from_screen: PROMO_SCREEN,
  screen: ADDRESS_SCREEN,
  heading: "Let's get physical"
}

export const AddressNextButton: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: ADDRESS_SCREEN
}
